// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { investigationCasesManifest } from './investigation-cases';
import { legalAdvisorManifest } from './legal-advisor';
import { legalCasesManifest } from './legal-cases';

/** Група модулів «Правова робота» (Legal): 3 модулів. */
export const legalGroup: IModuleGroupManifest = {
  key: 'legal',
  category: 'Legal',
  name: { en: 'Legal', uk: 'Правова робота' },
  sort: 14,
  modules: [investigationCasesManifest, legalAdvisorManifest, legalCasesManifest],
};
